import {useTranslation} from "react-i18next";
import {useHistory} from "react-router-dom";
import CRUDTable from "../CRUDTable";
import {formAttributeCRUD} from "../../../http";
import {FORM_ATTRIBUTE_DETAIL_ROUTE} from "../../../routes";
import React from "react";
import { page } from "../../../functions/resourceLinq1";

export default function FormAttributeCRUDTable({...props}) {
    const {t} = useTranslation();
    const {push} = useHistory();

    const columns = [
        {title: t("formAttributeList.tableItem.id") || "ID", dataIndex: "id", key:"id"},
        {title: t("formAttributeList.tableItem.type") || "Type", dataIndex: "type", key:"type"},
        {title: t("formAttributeList.tableItem.member") || "Member", dataIndex: "member", key:"member"},
        {title: t("formAttributeList.tableItem.number") || "Number", dataIndex: "number", key:"number"},
        {title: t("formAttributeList.tableItem.memberType") || "Member Type", dataIndex: "memberType", key:"memberType"},
        {title: t("formAttributeList.tableItem.memberDescription") || "Member Description", dataIndex: "memberDescription", key:"memberDescription"},
    ]

    const searchFields = [
        { title: t("formAttributeList.search.type") || "Type", key: "type", compareType: "contains", operandPosition:1, filterType:"normal" },
        { title: t("formAttributeList.search.member") || "Member", key: "member", compareType: "contains", operandPosition:1, filterType:"normal" },
        { title: t("formAttributeList.search.number") || "Number", key: "number", compareType: "contains", operandPosition:1, filterType:"normal" },
        { title: t("formAttributeList.search.memberType") || "Member Type", key: "memberType", compareType: "contains", operandPosition:1, filterType:"normal" },
        { title: t("formAttributeList.search.memberDescription") || "Member Description", key: "memberDescription", compareType: "contains", operandPosition:1, filterType:"normal" },
    ]

    return <CRUDTable
        search={formAttributeCRUD.search}
        columns={columns}
        onClickCreateButton={() => push(FORM_ATTRIBUTE_DETAIL_ROUTE("new"))}
        searchFields={searchFields}
        {...props}
    />
}


